import React, { Component } from 'react';
import { MainRouter } from '../Components/MainRouter';

import { t } from '../locales/i18n';
export class ErrorPage extends Component {
    static displayName = ErrorPage.name;

    constructor(props) {
        super(props);
       
        window.ga('set', 'page', window.location.pathname + window.location.search);
        window.ga('send', 'pageview');
    }

    render() {
        return (
            <MainRouter>
                <div className='searchBody'>
                    <h3>
                        {t('errorPage.title')}
                    </h3>
                    <div
                        className='instructions'
                        dangerouslySetInnerHTML={{ __html: t('errorPage.instructions') }}
                    ></div>
                    <button type='button' className='btn btn-primary' onClick={this.click}>
                        {t('errorPage.button')}
                    </button>
                </div>
            </MainRouter>
        );
    }

    click() {
        MainRouter.routeTo('/');
    }
}
